import { ReactElement, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { DocumentsListMobileProps, Document } from '../../../domain/documents.types'
import Checkbox from '../../components/checkbox'
import { filterData } from '../../components/table/table.helpers'
import { useStore } from '../../../application/store/store'
import { useDocumentUseCase } from '../../../application/useCases/useDocuments'
import {
  CenterWrapper,
  DocumentsListMobileWrapper,
  Row,
  Element,
  Name,
  ViewButton,
  StyledCategory,
} from './documents.styles'
import { Typography, Wrapper } from '../../../ui/components/globals'

const DocumentsListMobile = (props: DocumentsListMobileProps): ReactElement | null => {
  const store = useStore()
  const { downloadFile } = useDocumentUseCase()
  const { documentsList, filters, handleSelectItem, selectedItems } = props
  const memoizedFilteredData = useMemo(() => filterData(documentsList, filters), [
    documentsList,
    filters,
  ])
  const downloadSingleFile = (file: Document) => {
    downloadFile(file)
    store.setSingleFileDownloading
  }
  const isDocumentLoading = store.documentsLoading

  const getRowsData = (): ReactElement[] => {
    return memoizedFilteredData.map((document) => {
      return (
        <Row color={document.documentType}>
          <Element>
            <Checkbox
              name="selectItem"
              value="selectItem"
              checked={!!selectedItems.find((elem) => elem.sharepointId === document.sharepointId)}
              onChange={(event) => handleSelectItem(document, event)}
            />
          </Element>

          <Element style={{ flex: 1 }}>
            <Name>{document.displayName}</Name>
            <Wrapper
              flex-direction="column"
              marginTop="0.5rem"
              justifyContent="space-between"
              alignItems="baseline"
            >
              <Typography paddingTop="4px">{document.powerPlantName}</Typography>
              <StyledCategory width="fit-content" fontSize="0.5rem" color={document.reportType}>
                {document.reportType.toUpperCase()}
              </StyledCategory>
            </Wrapper>
          </Element>

          <Element>
            <ViewButton type="button" onClick={() => downloadSingleFile(document)}>
              <FontAwesomeIcon
                icon={document.loading ? 'spinner' : 'download'}
                spin={document.loading}
              />
            </ViewButton>
          </Element>
        </Row>
      )
    })
  }
  if (documentsList.length === 0 && !isDocumentLoading) return null
  return (
    <DocumentsListMobileWrapper>
      {isDocumentLoading ? (
        <CenterWrapper>
          <FontAwesomeIcon icon="spinner" spin size="lg" />
        </CenterWrapper>
      ) : (
        getRowsData()
      )}
    </DocumentsListMobileWrapper>
  )
}

export default DocumentsListMobile
